<template>
    <div class="toggle-play-button">
        <span class="button-icon icon-play" v-if="!isPlaying"></span>
        <span class="button-icon icon-stop" v-if="isPlaying"></span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "TogglePlayButton",
    props: {
        isPlaying: Boolean
    }
});
</script>

<style scoped>
.toggle-play-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
}

.button-icon {
    font-size: 2em;
    color: var(--white);
}
</style>
